import Vue from 'vue'
import Vuex from 'vuex'
import { isValidJwt, setHeaderAuth } from '@/utils'

import {
    authenticate,
    contactRecoverPassword,
    contactRegister,
    postContact,
    postBusinessAdvice,
    postClaim,
    comments,
    getDepartments,
    getProvinces,
    getDocumentsType,
    setPassword,
    getBusiness
} from '@/api'
import { getDistricts } from '../api';

Vue.use(Vuex);

const  state = {
    user: {},
    users: [],
    jwt: null
};

const  actions = {
    login(context, data) {
        return authenticate(data)
            .then(response => {
                console.log('entre a login desde store:', response.data)
                context.commit('setJwtToken', response.data.token)
                context.commit('setUserData', response.data.user)
            })
    },
    recoverPassword (context, data) {
        return contactRecoverPassword(data)
    },
    registerContact (context, data) {
        return contactRegister(data)
    },
    postComment (context, data) {
        return comments(data)
    },
    postContact (context, data) {
        return postContact(data)
    },
    postBusinessAdvice (context, data) {
        return postBusinessAdvice(data)
    },
    postClaim(context, data){
        return postClaim(data)
    },
    getDepartments(){
        return getDepartments()
    },
    getProvinces(context, data){
        return getProvinces(data)
    },
    getDistrict(context, data){
        return getDistricts(data)
    },
    getDocumentsTpye(context, data){
        return getDocumentsType(data)
    },
    setPasswords(context, data){
        return setPassword(data)
    },
    getBusiness (context, data) {
        return getBusiness(data)
    }
};

const  mutations = {
    setUserData (state, payload) {
        state.user = payload
        localStorage.user_name = payload.nombre
        localStorage.user_data = JSON.stringify(payload)
    },
    setJwtToken (state, payload) {
        localStorage.token = payload
        setHeaderAuth()
        state.jwt = payload.jwt
    }
};

const  getters = {
    isAuthenticated(state) {
        let token
        if (state.jwt) {
            token = state.jwt
        } else {
            token = localStorage.getItem('token')
        }
        return isValidJwt(token)

    }
};

const store = new Vuex.Store({
    state,
    actions,
    mutations,
    getters
});

export default store